import { useHistoricalVibes } from '../hooks/useHistoricalVibes'
import HistoricalVibesChart from '../components/charts/HistoricalVibesChart'

export default function Vibes() {
  const { historicalData, isLoading } = useHistoricalVibes(7)

  return (
    <div className="pb-20 pt-2">
      <div className="container mx-auto px-3 max-w-2xl">
        <h2 className="text-xl font-bold text-white mb-2 text-center">
          Historical Vibes
        </h2>
        <p className="text-sm text-gray-400 mb-6 text-center">
          Community sentiment over the last 7 days
        </p>

        {isLoading ? (
          <div className="glass-card rounded-3xl p-8 flex items-center justify-center">
            <div className="animate-pulse text-gray-400 font-medium">Loading data...</div>
          </div>
        ) : (
          <div className="glass-card rounded-3xl p-4">
            <HistoricalVibesChart data={historicalData} />
          </div>
        )}

        {/* Info Card */}
        <div className="mt-4 p-4 rounded-2xl bg-blue-500/10 border border-blue-500/20">
          <p className="text-xs text-blue-200 leading-relaxed">
            <strong className="text-blue-100 block mb-1">📊 How it works</strong>
            Each day's sentiment is calculated from all votes cast. Green bars represent bullish volume, red bars represent bearish volume.
          </p>
        </div>
      </div>
    </div>
  )
}

